import { OccConfig, ProductScope } from '@spartacus/core';

import occBackendConfig from './default-occ-config.json';

(occBackendConfig as OccConfig).backend = {
  ...occBackendConfig.backend,
  loadingScopes: {
    product: {
      details: {
        include: [ProductScope.LIST, ProductScope.VARIANTS]
      }
    }
  }
};

export { occBackendConfig };
